export const getProjectKey = (name?: string) => (
    name && name.toLowerCase().replace(/[^a-z]/g, '') || 'spaceseven'
);
